import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  .checkbox-list-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    background-color: ",
        ";\n  }\n\n  .ant-checkbox-wrapper {\n    padding: 0 16px;\n    min-height: 41px;\n    height: fit-content;\n    align-items: center;\n    margin-inline-start: 0;\n    font-size: 14px;\n    color: ",
        ";\n    width: 100%;\n\n    :hover {\n      background-color: rgba(27, 27, 41, 0.03);\n    }\n\n    .ant-checkbox {\n      top: 0;\n    }\n\n    .ant-checkbox + span {\n    }\n  }\n\n  .ant-checkbox-wrapper-checked {\n    .ant-checkbox + span {\n      font-weight: 600;\n      color: ",
        ";\n    }\n  }\n\n  .layout-1 {\n    li {\n      width: 100%;\n    }\n  }\n\n  .layout-2 {\n    li {\n      width: 50%;\n    }\n  }\n\n  .layout-3 {\n    li {\n      width: 33.3333%;\n      @media (max-width: 768px) {\n        width: 50%;\n      }\n    }\n  }\n\n  .list-wrapper {\n    overflow: hidden;\n    transition: height 0.35s ease;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { renderKoreanFilterName } from "@/components/Search/index";
import Icon from "@/components/icon/Icon";
import { ArrowDown, ArrowUp, Sizes } from "@/components/icon/IconList";
import themeGet from "@styled-system/theme-get";
import { Checkbox } from "antd";
import React, { useEffect, useState } from "react";
import styled, { useTheme } from "styled-components";
export const MobileFilterListItem = (param)=>{
    let { title , filterItem , handleFilter , selectedFilters , openSlider , sliderOpen  } = param;
    const theme = useTheme();
    const [dropdown, setDropdown] = useState("folding");
    const [layoutClassName, setLayoutClassName] = useState("layout-2");
    const [listHeight, setListHeight] = useState(0);
    const titleCount = selectedFilters.filter((filter)=>filter.key === title).length;
    const childRef = React.useRef(null);
    const foldingClick = ()=>{
        setDropdown(dropdown === "folding" ? "expanding" : "folding");
        if (dropdown === "folding") {
            openSlider(true, title);
            return;
        }
        openSlider(true, "");
    };
    const layout = ()=>{
        if (title === "brands") {
            setLayoutClassName("layout-1");
        } else if (title === "units") {
            setLayoutClassName("layout-3");
        }
    };
    const onCheckboxChange = (id, value)=>{
        handleFilter(title, id, value);
    };
    useEffect(()=>{
        layout();
    }, [
        title
    ]);
    useEffect(()=>{
        if (dropdown === "expanding" && childRef.current) {
            setListHeight(childRef.current.scrollHeight);
        }
        if (!sliderOpen.isOpen || renderKoreanFilterName(title) !== renderKoreanFilterName(sliderOpen.value)) {
            setDropdown("folding");
        }
        if (sliderOpen.isOpen && renderKoreanFilterName(title) === renderKoreanFilterName(sliderOpen.value)) {
            setDropdown("expanding");
        }
    }, [
        dropdown,
        sliderOpen.isOpen,
        sliderOpen.value
    ]);
    return /*#__PURE__*/ _jsxs(MobileFilterListItemWrapper, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "filter-title-wrapper title-".concat(dropdown),
                onClick: foldingClick,
                children: [
                    /*#__PURE__*/ _jsxs("p", {
                        children: [
                            renderKoreanFilterName(title),
                            titleCount > 0 && /*#__PURE__*/ _jsxs("span", {
                                children: [
                                    " ",
                                    titleCount
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Icon, {
                        icon: dropdown === "folding" ? ArrowDown : ArrowUp,
                        color: dropdown === "folding" ? theme.new.colors.sol_gray_600 : theme.new.colors.sol_gray_900,
                        size: Sizes.small
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "list-wrapper",
                style: {
                    height: dropdown === "expanding" ? listHeight : "0px"
                },
                children: /*#__PURE__*/ _jsx("ul", {
                    className: "checkbox-list-wrapper ".concat(layoutClassName),
                    ref: childRef,
                    children: filterItem.map((item, idx)=>{
                        if (title === "brands") {
                            return item.values.map((brand, itemIdx)=>{
                                let isChecked = false;
                                selectedFilters.map((filter)=>{
                                    if (title === filter.key && filter.value === brand.id.toString()) isChecked = true;
                                });
                                var _brand_label;
                                return /*#__PURE__*/ _jsx("li", {
                                    children: /*#__PURE__*/ _jsx(Checkbox, {
                                        checked: isChecked,
                                        onChange: ()=>onCheckboxChange(brand.id, item.value),
                                        children: (_brand_label = brand.label) !== null && _brand_label !== void 0 ? _brand_label : brand.value
                                    })
                                }, itemIdx);
                            });
                        } else {
                            if (!item.value) return;
                            let isChecked = false;
                            selectedFilters.map((filter)=>{
                                if (title === "units" && String(filter.value) === String(item.value)) {
                                    isChecked = true;
                                } else if (title === filter.key && String(filter.value) === String(item.value)) {
                                    isChecked = true;
                                } else if (title === "tickets" && String(filter.value) === String(item.id)) {
                                    isChecked = true;
                                }
                            });
                            var _item_label;
                            return /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx(Checkbox, {
                                    checked: isChecked,
                                    onChange: ()=>{
                                        if (title === "units") {
                                            onCheckboxChange(item.value, item.value);
                                        } else onCheckboxChange(item.id, item.value);
                                    },
                                    children: (_item_label = item.label) !== null && _item_label !== void 0 ? _item_label : item.value
                                })
                            }, idx);
                        }
                    })
                })
            })
        ]
    });
};
const MobileFilterListItemWrapper = styled.div.withConfig({
    componentId: "sc-fce6d94f-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_0, (props)=>props.theme.new.colors.sol_gray_600, themeGet("primary.0", "#000000"));
